import { ActionTree, GetterTree, MutationTree } from 'vuex'
import { RootState } from '~/types/store'
import { UserSubjectTool } from '~/types/subject-tools'

export interface ChatbotsState {
  userChatbots: UserSubjectTool[]
  activeSubjectChatbot: UserSubjectTool | Record<string, never>
}

export function state (): ChatbotsState {
  return ({
  userChatbots: [],
  activeSubjectChatbot: {}
})
}

export const mutations: MutationTree<ChatbotsState> = {
  SET_CHATBOTS (state, data: UserSubjectTool[]) {
    state.userChatbots = data;
  },
  SET_ACTIVE_SUBJECT_CHATBOT (state, data: UserSubjectTool) {
    state.activeSubjectChatbot = data;
  }
};

export const getters: GetterTree<ChatbotsState, RootState> = {
  getUserChatbots (state) {
    return state.userChatbots;
  },
  getActivatedUserChatbots (state) {
    return state.userChatbots.filter(chatbot => chatbot.isActive === true);
  },
  getActiveSubjectChatbot (state) {
    return state.activeSubjectChatbot;
  }
};

export const actions: ActionTree<ChatbotsState, RootState> = {
  async getChatbots ({ commit }) {
    try {
      const { data } = await this.$axios.get(
        '/v1/users/me/chatbots'
      );
      commit('SET_CHATBOTS', data);
    } catch (e) {
      console.error(e);
    }
  },
  async getChatbotById ({ commit }, id: number | string) {
    try {
      const { data } = await this.$axios.get(
        `/v1/users/me/chatbots/${String(id)}`
      );
      commit('SET_ACTIVE_SUBJECT_CHATBOT', data);
    } catch (e) {
      console.error(e);
    }
  }
};
